import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { selectUser } from '@shared/store/selectors/user.selectors';
import { contactDetailTokenizer } from '@data-access/profiles/store/token/contact.token';

/**
 * V1 resolver for the logged-in user's own profile page (/user/profile).
 *
 * Unlike `contactResolver` (which reads an :id route param for viewing
 * another user's profile), this resolver reads the current user's ID
 * from the ngrx store and loads it into the V1 contactDetailTokenizer
 * signal store — the same store that ContactFacadeService reads from.
 *
 * Used in user-routing.module.ts when USER_SITE_SERVICE_V2 flag is OFF.
 */
export const userProfileV1Resolver = () => {
  const store = inject(Store);
  const contactStore = contactDetailTokenizer();

  store
    .select(selectUser)
    .pipe(take(1))
    .subscribe((user) => {
      if (user?.id) {
        contactStore.loadContact(user.id);
        contactStore.loadDegrees();
        contactStore.loadSpecialties();
        contactStore.loadCountries();
      }
    });

  return !!contactStore;
};
